import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthService } from '../services/auth';
import { isSuperAdmin } from '../constants/super-admin.constants';

/**
 * Route guard that restricts access to super admin pages.
 *
 * This guard checks two conditions:
 * 1. User must be logged in
 * 2. User's email must be in the super admin list
 *
 * If either condition fails, the user is redirected to the home page.
 *
 * @example
 * ```typescript
 * // In app-routing.module.ts
 * { path: 'super-admin', component: SuperAdminComponent, canActivate: [SuperAdminGuard] }
 * ```
 *
 * @see src/app/shared/constants/super-admin.constants.ts
 */
@Injectable({
  providedIn: 'root'
})
export class SuperAdminGuard implements CanActivate {

  constructor(
    public authService: AuthService,
    public router: Router
  ) { }

  canActivate(
    _route: ActivatedRouteSnapshot,
    _state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {

    // First check if user is logged in
    if (this.authService.isLoggedIn !== true) {
      this.router.navigate(['']);
      return false;
    }

    // Check if user email is in super admin list
    const userEmail = this.authService.userData?.email;
    if (!isSuperAdmin(userEmail)) {
      this.router.navigate(['']);
      return false;
    }

    return true;
  }

}
